import logo from "./logo.svg";
import "./App.css";
import Error from "./Pages/Error";
import Layout from "./Components/Shared/Layout";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,  
} from "react-router-dom";
import CustomerServices from "./Pages/CustomerServices/CustomerServices";
import CustomerServiceDetails from "./Pages/CustomerServices/CustomerServiceDetails";
import GetChristmasSorted from "./Pages/GetChristmasSorted/GetChristmasSorted";
import HampersPage from "./Pages/Hampers/HampersPage";
import ThemePage from "./Pages/Hampers/ThemePage";
import HamperDetails from "./Pages/Hampers/HamperDetails";
import GiftDetails from "./Pages/Gifts/Details/GiftDetails";
import ProductsPage from "./Pages/Products/ProductsPage";
import ProductCategoryPage from "./Pages/Products/ProductCategoryPage";
import OccasionPage from "./Pages/Occasions/OccasionPage";
import OccasionCatergory from "./Pages/Occasions/OccasionCatergory";
import SpecificHamper from "./Pages/Occasions/SpecificHamper";
import Wholesale from "./Pages/Wholesale/Wholesale";
import WholesaleProducts from "./Pages/Wholesale/WholesaleProducts";
import NewHomePage from "./Pages/Home/NewHomePage";


function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        { index: true, element: <NewHomePage /> },
        {
          path: "/Customer-Services",
          element: <CustomerServices />,
        },
        {
          index: true,
          element: <CustomerServiceDetails />,
          path: "/Customer-Services/:info",
        },
        {
          path: "/Gifts",
          element: <Navigate to="/Products" replace />
        },
        {
          path: "/Gifts/:Selection",
          element: <Navigate to="/Products" replace />
        },
        // {
        //   path: "/Gifts/:id/:category",
        //   element: <GiftsDetails />,
        // },
        {
          index: true,
          path: "/Hampers",
          element: <OccasionPage/>
        },
        {
          index: true,
          path: "/Hampers/:ThemeName",
          element: <ThemePage/>,         

        },
        {
          index: true,
          path: "/Hampers/:ThemeName/:HamperName",
          element: <HamperDetails/>
        },
        {
          index: true,
          path: "/Products",
          element: <ProductsPage/>
        },
        {
          index: true,
          path: "/Products/:CategoryProduct/:Product",
          element: <ProductCategoryPage/>
        },
        {
          index: true,
          path: "/Products/:CategoryProduct",
          element: <ProductCategoryPage/>
        },
        {
          index: true,
          path: "Occasions",
          element: <OccasionPage/>
        },
        {
          index: true,
          path: "Occasions/:OccasionName",
          element: <OccasionCatergory/>
        },
        {index: true,
          path: "Occasions/:OccasionName/:HamperName",
          element: <SpecificHamper/>
        },
        {
          index: true,
          path: "Wholesale",
          element: <Wholesale/>
        },
        {
          index: true,
          path: "Wholesale/Products",
          element: <WholesaleProducts/>
        },
        {
          index: true,
          path: "Wholesale/Products/:CategoryProduct/:Product",
          element: <ProductCategoryPage/>
        },
        {
          index: true,
          path: "Wholesale/Products/:CategoryProduct",
          element: <ProductCategoryPage/>
        },
        {
          index: true,
          path: "Get-Christmas-Sorted",
          element: <GetChristmasSorted/>
        },
        {
          index: true,
          path: "GetChristmasSorted",
          element: <GetChristmasSorted/>
        }
      ],
      errorElement: <Error />,
    },
  ]);

  
  return <RouterProvider router={router} />;
}

export default App;
